import { AppBar, Button, IconButton, Toolbar, styled } from "@mui/material";
import { NewReportDialog } from "./components/NewReportDialog";
import { useState } from "react";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { SignOutDialog } from "./components/SignOutDialog";
import { PlantSelector } from "./components/PlanSelector";

const Body = styled("div")<{ bigHeader?: boolean }>`
  display: flex;
  background: ${(props) => props.theme.palette.primary.main};
  flex-direction: column;
  align-items: stretch;
  padding: 0 30px;
  margin: auto;
  margin-top: 56px;
  min-height: calc(100vh - 56px);
  ${(props) => props.theme.breakpoints.up(600)} {
    margin-top: 64px;
    min-height: calc(100vh - 64px);
  }

  ${(props) => props.theme.breakpoints.up(0)} @media (orientation: landscape) {
    margin-top: 48px;
    min-height: calc(100vh - 48px);
  }
`;
const ButtonGroup = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 46px;
  justify-content: center;
  align-items: stretch;
  flex-grow: 1;
  margin: auto;
  margin-top: -56px;
`;
const OptionButton = styled(Button)`
  text-transform: uppercase;
  border-radius: 16px;
  background-color: white;
  border: 1px solid black;
  min-width: 250px;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const Home = () => {
  const [showSignOutDialog, setShowSignOutDialog] = useState(false);
  const closeSignOutDialog = () => {
    setShowSignOutDialog(false);
  };
  const signout = () => {
    closeSignOutDialog();
    setShowSignOutDialog(true);
  };
  const [showNewReportDialog, setShowNewReportDialog] = useState(false);

  return (
    <Body>
      <AppBar position="fixed" sx={{ background: "white" }}>
        <Toolbar>
          {location.pathname !== "/" && (
            <Link to="/">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, color: "white" }}
              >
                <HomeIcon />
              </IconButton>
            </Link>
          )}
          <PlantSelector />
          <Link to={"/"}>
            <img src={"/logo.png"} alt="logo" />
          </Link>
        </Toolbar>
      </AppBar>
      <ButtonGroup>
        <OptionButton
          variant="contained"
          onClick={() => setShowNewReportDialog(true)}
        >
          Nuevo Reporte
        </OptionButton>
        <Link to="/historial">
          <OptionButton variant="contained">Historial Reportes</OptionButton>
        </Link>
        <OptionButton variant="contained" onClick={signout}>
          Cerrar sesión
        </OptionButton>
      </ButtonGroup>
      {showNewReportDialog && (
        <NewReportDialog onClose={() => setShowNewReportDialog(false)} />
      )}
      {showSignOutDialog && <SignOutDialog onClose={closeSignOutDialog} />}
    </Body>
  );
};
